import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

const isDev = window.location.hostname === 'localhost' || window.location.hostname.match(/^(127\.|10\.|172\.(1[6-9]|2\d|3[01])\.|192\.168\.)/);
const BASE_URL = isDev
  ? `http://${window.location.hostname}:3000/api`
  : '/api';

@Injectable({ providedIn: 'root' })
export class WorkspaceValidatorService {
  private _valid = true;

  get isValid(): boolean { return this._valid; }

  constructor(private router: Router) {}

  async validate(): Promise<void> {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') return;

    const parts = host.split('.');
    if (parts.length < 3) return;

    try {
      const res = await fetch(`${BASE_URL}/health`);
      if (res.status === 404) {
        this._valid = false;
        this.router.navigateByUrl('/workspace-not-found');
      }
    } catch {
      // Network error — let the app load normally, login will surface the issue
    }
  }
}
